import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom"
import { ActivationProgressBar } from "@/components/activation/ActivationProgressBar"
import { AppHeader } from "@/components/dashboard/AppHeader"
import { useActivation } from "@/lib/activation-context"
import { useSession } from "@/lib/session-context"
import { effectiveActivationStep, TOTAL_STEPS } from "@/lib/activation"

const STEP_RE = /^\/activation\/step\/(\d+)/

export function ActivationShell() {
  const { currentUser } = useSession()
  const { currentStep, step2, isHydrating } = useActivation()
  const location = useLocation()
  const navigate = useNavigate()

  if (!currentUser) return <Navigate to="/" replace />
  if (isHydrating) return null

  const activationStep = effectiveActivationStep(currentStep, step2)
  const activationComplete = activationStep > TOTAL_STEPS
  const stepMatch = STEP_RE.exec(location.pathname)
  if (!stepMatch && activationComplete) return <Navigate to="/dashboard" replace />

  if (stepMatch) {
    const n = Number(stepMatch[1])
    if (!Number.isInteger(n) || n < 1 || n > TOTAL_STEPS) {
      return <Navigate to={`/activation/step/${Math.min(activationStep, TOTAL_STEPS)}`} replace />
    }
    if (activationStep <= TOTAL_STEPS && n > activationStep) {
      return <Navigate to={`/activation/step/${activationStep}`} replace />
    }
  }

  return (
    <main className="min-h-screen bg-background text-foreground">
      <AppHeader
        status={activationComplete ? "online" : "standby"}
        planName={activationComplete ? "Pro" : "Beta"}
        showNav={activationComplete}
      />
      <ActivationProgressBar
        currentStep={activationStep}
        totalSteps={TOTAL_STEPS}
        onStepClick={(step) => navigate(`/activation/step/${step}`)}
      />
      <Outlet />
    </main>
  )
}
